import LoserModal from './loser-modal';
export default LoserModal;
